import React from 'react';
import Icon from 'components/AppIcon';


export default function AccountPagination({ currentPage, totalPages, totalItems, pageSize, onPageChange, onPageSizeChange }) {
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);

  const pages = [];
  const delta = 2;
  for (let i = Math.max(1, currentPage - delta); i <= Math.min(totalPages, currentPage + delta); i++) {
    pages?.push(i);
  }

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-border bg-card">
      <div className="flex items-center gap-3">
        <span className="font-caption text-sm text-muted-foreground">
          Showing {start}–{end} of {totalItems} accounts
        </span>
        <div className="flex items-center gap-2">
          <span className="font-caption text-xs text-muted-foreground">Per page:</span>
          <select
            className="h-8 px-2 text-xs border border-border rounded-md bg-background text-foreground font-caption appearance-none focus:outline-none focus:ring-2 focus:ring-ring"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e?.target?.value))}
          >
            {[10, 20, 50, 100]?.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <button
          className="w-8 h-8 flex items-center justify-center rounded-md border border-border bg-background text-muted-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          aria-label="First page"
        >
          <Icon name="ChevronsLeft" size={14} color="currentColor" strokeWidth={2} />
        </button>
        <button
          className="w-8 h-8 flex items-center justify-center rounded-md border border-border bg-background text-muted-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          <Icon name="ChevronLeft" size={14} color="currentColor" strokeWidth={2} />
        </button>

        {pages?.[0] > 1 && (
          <>
            <button className="w-8 h-8 flex items-center justify-center rounded-md border border-border bg-background text-sm font-caption text-muted-foreground hover:bg-muted transition-colors" onClick={() => onPageChange(1)}>1</button>
            {pages?.[0] > 2 && <span className="w-8 h-8 flex items-center justify-center font-caption text-muted-foreground text-sm">…</span>}
          </>
        )}

        {pages?.map(p => (
          <button
            key={p}
            className={`w-8 h-8 flex items-center justify-center rounded-md border text-sm font-caption transition-colors ${
              p === currentPage
                ? 'border-primary bg-primary text-primary-foreground font-medium'
                : 'border-border bg-background text-muted-foreground hover:bg-muted'
            }`}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        ))}

        {pages?.[pages?.length - 1] < totalPages && (
          <>
            {pages?.[pages?.length - 1] < totalPages - 1 && <span className="w-8 h-8 flex items-center justify-center font-caption text-muted-foreground text-sm">…</span>}
            <button className="w-8 h-8 flex items-center justify-center rounded-md border border-border bg-background text-sm font-caption text-muted-foreground hover:bg-muted transition-colors" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
          </>
        )}

        <button
          className="w-8 h-8 flex items-center justify-center rounded-md border border-border bg-background text-muted-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next page"
        >
          <Icon name="ChevronRight" size={14} color="currentColor" strokeWidth={2} />
        </button>
        <button
          className="w-8 h-8 flex items-center justify-center rounded-md border border-border bg-background text-muted-foreground hover:bg-muted disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          aria-label="Last page"
        >
          <Icon name="ChevronsRight" size={14} color="currentColor" strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}